import React, { useState, useCallback, useEffect } from "react";
import './index.css'; 
import { BrowserRouter as Router, Routes, Route, useNavigate } from "react-router-dom";
import MapLayer from "./components/MapLayer";
import ScopeLayer from "./components/ScopeLayer";
import UILayer from "./components/Ui/UILayer";
import OpeningLayer from "./components/OpeningLayer";
import TrajectoryManager from "./components/TrajectoryManager";
import TrajectoryManager_tama from "./components/TrajectoryManager_tama";
import TrajectoryManager_tokyo from "./components/TrajectoryManager_tokyo";
import { RecordingStatus } from "./components/enum";


/** データの指定 */
// 日野多摩
import railHinotamaStopData from './data/hinotama-RAIL-Stop.json';
import busHinotamaStopData from './data/hinotama-BUS-Stop.json';
import railHinotamaTripData from './data/hinotama-RAIL-Trip.json';
import busHinotamaTripData from './data/hinotama-BUS-Trip.json';
const hinotamaStopsData = [railHinotamaStopData,busHinotamaStopData].flat();
const hinotamaTripsData = [railHinotamaTripData,busHinotamaTripData].flat();
const hinotamaInitialLocation = {lat: 35.62522899676183,lng: 139.42446066517738,zoomLv: 15}; // 初期位置 多摩ニュータウン中央

// 山の手
import metroStopData from './data/TokyoMetro-Train-GTFS-Stop.json';
import metroTripData from './data/TokyoMetro-Train-GTFS-Trip.json';
import jrStopData from './data/JR-East-Train-GTFS-Stop.json';
import jrTripData from './data/JR-East-Train-GTFS-Trip.json';
import toeiStopData from './data/Toei-Train-GTFS-Stop.json';
import toeiTripData from './data/Toei-Train-GTFS-Trip.json';
import tobusStopData from './data/ToeiBus-GTFS-Stop.json';
import tobusTripData from './data/ToeiBus-GTFS-Trip.json';
const yamanoteStopsData = [metroStopData,jrStopData,toeiStopData,tobusStopData].flat();
const yamanoteTripsData = [metroTripData,jrTripData,toeiTripData,tobusTripData].flat();
const yamanoteInitialLocation = {lat: 35.6851154288043 ,lng: 139.75284614443527, zoomLv: 12}; // 初期位置 皇居

const startTimestamp = 60 * 60 * 7; // 7:00 シミュレーションスタートのタイムスタンプ


/** ページ定義 */
// オープニングページ
const OpeningPage = ({ onSelect }) => (
  <div>
    <OpeningLayer onSelect={onSelect} />
  </div>
);

// シミュレート画面
const SimulatorPage = ({
  mapInstance,
  handleMapLoad,
  handleTimeUpdate,
  startTimestamp,
  currentTime,
  anothreSimulatorName,
  linkToAnothreSimulator,
  data,
  initialVeiw,
  canReport,
}) => {
  /** 状態管理 */
  // リポート
  const [showReport,setShowReport] = useState(false); // リポート表示フラグ
  const [recordingStatus,setRecordingStatus] = useState(RecordingStatus.NONE); // 記録状態の管理
  // スライダー
  const [sliderValues, setSliderValues] = useState({}); // スライダーの値

  const[reverse,setReverse] =useState(false);

  /** メソッド */
  //SETTING スライダーの値を受け取る
  const handleValueChange = (sliderId, value) => {
    console.log(sliderId,value)
    setSliderValues((prev) => ({
      ...prev,
      [sliderId]: value, // スライダーごとに値を更新
    }));
  };

  

  useEffect(() => {
    if (showReport) {
      document.body.classList.add("scroll-enabled"); // スクロールを有効化
    } else {
      document.body.classList.remove("scroll-enabled"); // スクロールを無効化
    }
  
    // クリーンアップ処理
    return () => {
      document.body.classList.remove("scroll-enabled"); // 万が一のため削除
    };
  }, [showReport]);
  
  return (
    <div>
    <MapLayer onMapLoad={handleMapLoad} showReport={showReport} initialView={initialVeiw}/>
    {mapInstance && (

linkToAnothreSimulator === "/simulator_yamanote" ? (
  // Tama 用の TrajectoryManager
  <TrajectoryManager_tama
    map={mapInstance}
    tripData={data.trip}
    stopData={data.stop}
    playbackSpeed={sliderValues[3]}
    onTimeUpdate={handleTimeUpdate}
    startTimestamp={startTimestamp}
    showRepot={showReport}
    setShowReport={setShowReport}
    recordingStatus={recordingStatus}
    setRecordingStatus={setRecordingStatus}
    trainCoverage={sliderValues[1]}
    busCoverage={sliderValues[2]}
    reverse={reverse}
  />
) : (
  // デフォルトの TrajectoryManager
  <TrajectoryManager_tokyo
    map={mapInstance}
    tripData={data.trip}
    stopData={data.stop}
    playbackSpeed={sliderValues[3]}
    onTimeUpdate={handleTimeUpdate}
    startTimestamp={startTimestamp}
    showRepot={showReport}
    setShowReport={setShowReport}
    recordingStatus={recordingStatus}
    setRecordingStatus={setRecordingStatus}
    trainCoverage={sliderValues[1]}
    busCoverage={sliderValues[2]}
    reverse={reverse}
  />
)

    )}

    {!showReport && (<ScopeLayer/>)}
    {!showReport && (
      <UILayer 
        currentTime={currentTime}
        onSliderChange={handleValueChange}
        recordingStatus={recordingStatus}
        setRecordingStatus={setRecordingStatus}
        setShowReport={setShowReport}
        canReport={canReport}
        reverse={reverse}
        setReverse={setReverse}
      />
    )} 
  </div>
  )
};

/**
 * mainとなるAppメソッド
 * @returns
 */
const App = () => {
  const [mapInstance, setMapInstance] = useState(null);
  const [currentTime, setCurrentTime] = useState(0);


  const handleMapLoad = useCallback((map) => {
    setMapInstance(map);
  }, []);

  const handleTimeUpdate = useCallback((time) => {
    setCurrentTime(time);
  }, []);



  const navigate = useNavigate();

  const moveToSimulator = (selectedText) => {
    if (selectedText === "suburban") {
      navigate("/simulator_tama");
    } else if (selectedText === "urban") {
      navigate("/simulator_yamanote");
    }
  };


  return (
    <div>
      <Routes>
        <Route
          path="/"
          element={<OpeningPage onSelect={moveToSimulator} />}
        />
        <Route
          path="/simulator_tama"
          element={
            <SimulatorPage
              mapInstance={mapInstance}
              handleMapLoad={handleMapLoad}
              handleTimeUpdate={handleTimeUpdate}
              startTimestamp={startTimestamp}
              currentTime={currentTime}
              anothreSimulatorName={"SIMULATOR YAMANOTE"}
              linkToAnothreSimulator={"/simulator_yamanote"}
              data={{trip: hinotamaTripsData, stop: hinotamaStopsData}}
              initialVeiw={hinotamaInitialLocation}
              canReport={true}
         
            />
          }
        />
        <Route
          path="/simulator_yamanote"
          element={
            <SimulatorPage
              mapInstance={mapInstance}
              handleMapLoad={handleMapLoad}
              handleTimeUpdate={handleTimeUpdate}
              startTimestamp={startTimestamp}
              currentTime={currentTime}
              anothreSimulatorName={"SIMULATOR TAMA"}
              linkToAnothreSimulator={"/simulator_tama"}
              data={{trip: yamanoteTripsData, stop: yamanoteStopsData}}
              initialVeiw={yamanoteInitialLocation}
              canReport={false}
              
            />
          }
        />
      </Routes>
    </div>
  );
};

// アプリのエントリーポイント
const RootApp = () => (
  <>
    <App />
  </>
);

export default RootApp;